<style scoped>
table.table-cells-180 th,
table.table-cells-180 td {
  min-width: 180px !important;
  border: 1px solid #dee2e6;

}
table.table-cells-180 td{
  background: #ffffff;
}

checkbox {
  max-width: 50px !important;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0rem !important;
  border-bottom-right-radius: 0rem !important;
}
</style>

<template>
  <div class="col-md-12">
    <div class="card border-bottom-0 rounded-bottom-0">
      <div class="card-header border-bottom-0">
        <h4 class="float-left d-none d-md-block">Händler Kalk nach Gruppen</h4>
        <!-- Default switch s-->

        <button type="button" class="btn btn-primary ml-2 float-right" @click="save()">Speichern</button>

        <b-form-select
            class="float-right col-md-5 col-xl-4 col-sm-10"
            id="sctMarketAccount"
            :options="marketAccounts"
            :disabled="pendingChanges"
            v-model="currentlySelectedMarketAccountId"
        ></b-form-select>

        <button type="button" class="btn btn-primary mr-2 float-right" @click="popupCreateVendorGroup()">Händlergruppe erstellen</button>

      </div>
    </div>
<!--    v-bind:style="{ 'height': tHeight + 'px' }"-->
    <div  class="">
      <table
        class="table table-bordered table-hover striped table-sm table-cells-180"
        v-if="items.length > 0"
      >
        <thead>
          <tr>
            <th>
              <span>Lieferantgruppe</span>
            </th>

						<th>fix min. Aufschlag</th>
						<!-- fixedChargeNewMin -->
						<th>min. Aufschlag in %</th>
						<!-- percentCharge[new]Min -->
						<th>fix max. Aufschlag</th>
						<!-- fixedChargeNewMax -->
						<th>max. Aufschlag in %</th>
						<!-- percentCharge[new]Max -->
            <th>Repricing-Puffer</th>
            <!-- percentCharge[new]Max -->
          </tr>
        </thead>

        <tbody v-if="vendorGroups.length > 0">
          <tr
            v-for="(item, itr) in vendorGroups"
            v-bind:key="itr"
          >
          	<template v-if="item.values">
							<td>
								<div>
									<b :id="'vendorGroupName'+itr"> {{ item.name }}</b><br>
									<span
										style="
											display:inline-block;
											max-width:180px;
											white-space:nowrap;
											overflow:hidden;
											text-overflow:ellipsis;
											vertical-align:bottom;
										"
										class="pointer"
										@click="openGroupModal(item)"
									>
										{{ item.members?.map(memberId => vendors.find(v => v.value === memberId)?.text).join(', ') }}
									</span>
								</div>
							</td>
							<td>
								<!-- Price Max -->
								<div class="input-group input-group-sm">
									<input
										type="text"
										style="text-align: right;"
										class="form-control"
										required
										v-model="item.values.fixedChargeNewMin"
									/>
									<div class="input-group-append mb-auto">
										<span class="input-group-text">€</span>
									</div>
								</div>
							</td>

							<td>
								<!-- percentCharge[new/used]Min -->
								<div class="input-group input-group-sm">
									<input
											type="text"
											style="text-align: right;"
											class="form-control"
											required
											v-model="item.values.percentChargeNewMin"
									/>
									<div class="input-group-append mb-auto">
										<span class="input-group-text">%</span>
									</div>
								</div>
							</td>

							<td>
								<!-- Fixed Charge max -->
								<div class="input-group input-group-sm">
									<input
										type="text"
										style="text-align: right;"
										class="form-control"
										required
										v-model="item.values.fixedChargeNewMax"
									/>
									<div class="input-group-append mb-auto">
										<span class="input-group-text">€</span>
									</div>
								</div>
							</td>


							<td>
								<!-- percentCharge[newMax -->
								<div class="input-group input-group-sm">
									<input
										type="text"
										style="text-align: right;"
										class="form-control"
										required
										v-model="item.values.percentChargeNewMax"
									/>
									<div class="input-group-append mb-auto">
										<span class="input-group-text">%</span>
									</div>
								</div>
							</td>

							<td>
								<!-- repricingBufferNew -->
								<div class="input-group input-group-sm">
									<input
										type="text"
										style="text-align: right;"
										class="form-control"
										required
										v-model="item.values.repricingBufferNew"
									/>
									<div class="input-group-append mb-auto">
										<span class="input-group-text">€</span>
									</div>
								</div>
							</td>
						</template>
          </tr>
        </tbody>
      </table>
    </div>

    <!--vendor group modal--->
    <b-modal v-model="modalShowVendorGroup" scrollable>
      <template #modal-header>
        <h5 class="">Händlergruppe erstellen</h5>
        <div class="w-50">
          <div class="form-group float-right">
            <input type="text" class="form-control" id="vendorGroupName" placeholder="Gruppenname" v-model="vendorGroup.name" />
          </div>
        </div>
      </template>


        <table
            class="table table-bordered table-hover striped table-sm"
        >
          <thead>
            <tr>
              <th>
                Lieferant auswählen
              </th>
              <th>
                <button type="button" class="btn btn-secondary btn-sm" @click="switchVendorSort()" :disabled="pendingChanges">
                  <span v-if="sortAscendingOrDescending == 1" class="icon icon-sort-alpha-asc"></span>
                  <span v-else class="icon icon-sort-alpha-desc"></span>
                </button>
                <span>Lieferant</span>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr
                v-for="(vendor, itr) in vendors"

                v-bind:key="vendor.value"
            >
              <td class="mx-auto" :id="itr">
                <b-form-checkbox
                    :id="'isSelected-'+ vendor.value"
                    v-model="vendor.isSelected"
                    name="checkbox-1"
                    value="true"
                    unchecked-value="false"
                ></b-form-checkbox>
              </td>
              <td>
                <div>
                  <b>{{vendor.text}}</b>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

      <template #modal-footer="{ ok, cancel }">
        <b-button size="sm" variant="secondary"  @click="vendorGroupClose()">
          abbruch
        </b-button>

        <b-button size="sm" variant="primary"  @click="saveVendorGroup()">
          speichern
        </b-button>
      </template>
    </b-modal>
		<b-modal v-model="modalShowGroupDetails" hide-header hide-footer scrollable>
			<h5>{{ selectedGroup.name }}</h5>
			<ul>
				<li v-for="member in selectedGroup.members" :key="member">
					{{ vendors.find(v => v.value === member)?.text }}
				</li>
			</ul>
		</b-modal>
    <modal-error-component v-model="modalError"></modal-error-component>
  </div>
</template>



<script>
export default {
  props: ["passedVendors", "passedMarketAccounts", "passedVendorGroups"],
  data() {
    return {
      items: [],
      oldItems: [],
      changedItems: [],
      vendorOrMarketAccount: false,
      marketAccounts: this.passedMarketAccounts,
      vendors: [],
      currentlySelectedMarketAccountId: 1,
      currentlySelectedVendorId: 1,
      popupCreateRuleVendorId: -1,
      sortAscendingOrDescending: 1,
      sortAscendingOrDescendingWatchBlock: false, // prevents pendingChanges from triggering, if items are being resorted.
      modalShow_createNewRule: false,
      vendorGroups: [],
      vendorGroup: {
        name: "",
        members: [],
      },
      modalShowVendorGroup: false,
      tHeight: window.innerHeight - 200,
      pendingChanges: false,
			selectedGroup: {
				name: '',
				members: []
			},
			modalShowGroupDetails: false,
      modalError: {
        show: false,
        message: 'unpopulated',
        error: 'unpopulated',
        title: 'unpopulated'
      },
    };
  },

  watch: {
    currentlySelectedMarketAccountId: function() {
      this.loadItems();
    },
    currentlySelectedVendorId: function() {
      this.currentlySelectedVendorId = parseInt(this.currentlySelectedVendorId);
      this.loadItems();
    },
    items: {
      handler: function() {
        if(this.modalShowVendorGroup) return;
        if(!this.sortAscendingOrDescendingWatchBlock) {
          this.pendingChanges = true;
        }else{
          this.sortAscendingOrDescendingWatchBlock = false;
        }
      },
      deep: true
    }
  },
  computed: {
    alreadyUsedVendors() {
      return this.vendorGroups.reduce((acc, group) => {
        // Assuming each group has a `members` array with vendor IDs
        return acc.concat(group.members);
      }, []);
    },
    selectedVendors() {
      return this.vendors.filter(vendor => vendor.isSelected);
    },
  },
  methods: {
    loadItems() {
      var uri = "/vendormarketaccount/";
      if (this.vendorOrMarketAccount == true) {
        uri += "itemsbyvendor/" + this.currentlySelectedVendorId;
      } else {
        uri += "itemsbymarketaccount/" + this.currentlySelectedMarketAccountId;
      }
      axios.get(uri).then(response => {
        this.items = response.data;
        this.vendors = this.vendors.map(vendor => {
          this.$set(vendor, 'isSelected', false);
          return vendor;
        })
        this.oldItems = _.cloneDeep(this.items);
        this.sortItems(false);
        this.formatItems();
				this.vendorGroups = this.vendorGroups.map(group => {
					group.values = this.items.find(item =>
							group.members.some(member => member == item.vendorId)
					);
					return group;
				});
        Vue.nextTick(() => { //probably redundant because of sortItems containing pendingChanges switch already!
          this.pendingChanges = false;
        });
      }).catch((error) => {
        this.modalError = {
          show: true,
          message: 'Items konnten nicht geladen werden.',
          error: error,
          title: 'Market Accounts Laden'
        }

      });
    },

    switchVendorSort() {
      this.sortAscendingOrDescending *= -1;
      this.sortItems(false);
    },
    errorWrapper(itemValue, item, name) {
      console.log("errorWrapper called for item: ");
      console.log(itemValue);
      this.modalError = {
        show: true,
        message: "Eingabe für " + name + " fehlerhaft: " + itemValue,
        error: JSON.stringify(item, null, 2),
        title: 'Validierung'
      };
    },
    validateItems() {
      const isNotNumeric  = x => (x.search(/[^0-9|.|-]/) != -1 || (x.split(".").length > 2) ||  x.search("-") > 0);
      const isNotIntegral = z => (z.search(/[^0-9]/) == -1);

      this.items.forEach((item) => {
        // convert everything to string if it is not. Validation assumes that 
        // all cells are strings, why I do not understand. (This was done because if creating new item, fixedChargeNewMin
        // and all other fields are integers, and Integer primitives do not have .replace() function, which causes a silent error!
        if(typeof item.fixedChargeNewMin !== 'string') item.fixedChargeNewMin = item.fixedChargeNewMin.toString();
        if(typeof item.fixedChargeNewMax !== 'string') item.fixedChargeNewMax = item.fixedChargeNewMax.toString();
        if(typeof item.percentChargeNewMin !== 'string') item.percentChargeNewMin = item.percentChargeNewMin.toString();
				if(typeof item.percentChargeNewMax !== 'string') item.percentChargeNewMax = item.percentChargeNewMax.toString();
				if(typeof item.repricingBufferNew !== 'string') item.repricingBufferNew = item.repricingBufferNew.toString();

        item.fixedChargeNewMin = item.fixedChargeNewMin.replace(",", ".");
        item.fixedChargeNewMax = item.fixedChargeNewMax.replace(",", ".");
        item.percentChargeNewMin = item.percentChargeNewMin.replace(",", ".");
				item.percentChargeNewMax = item.percentChargeNewMax.replace(",", ".");
				item.repricingBufferNew = item.repricingBufferNew.replace(",", ".");

        if (isNotNumeric(item.fixedChargeNewMin)) this.errorWrapper(item.fixedChargeNewMin, item, 'fix min. Aufschlag');
        if (isNotNumeric(item.fixedChargeNewMax)) this.errorWrapper(item.fixedChargeNewMax, item,  'fix max. Aufschlag');
        if (isNotNumeric(item.percentChargeNewMin)) this.errorWrapper(item.percentChargeNewMin, item, 'min. Aufschlag in %');
				if (isNotNumeric(item.percentChargeNewMax)) this.errorWrapper(item.percentChargeNewMax, item, 'max. Aufschlag in %');
				if (isNotNumeric(item.repricingBufferNew)) this.errorWrapper(item.repricingBufferNew, item, 'Repricing-Puffer');

			});
    },

    save() {
      this.popupCreateRuleVendorId = -1;
      this.validateItems();
      this.updateAllVendorGroupMembers();
      this.checkForChanges();

      this.items.forEach(item => {
        delete item.isSelected;
      });

      axios.post("/vendormarketaccount/createorupdate", this.items)
          .then(response => {
            this.loadItems();

            const propertyToFilter = this.vendorOrMarketAccount ? 'marketAccountId' : 'vendorId';
            const pluralPropertyToFilter = `${propertyToFilter}s`
            const IdForRecomputation = !this.vendorOrMarketAccount ? 'marketAccountId' : 'vendorId';

            let  request = {
              vendorOrMarketAccount: this.vendorOrMarketAccount,
              [IdForRecomputation] : this.vendorOrMarketAccount ? this.currentlySelectedVendorId : this.currentlySelectedMarketAccountId,
              [pluralPropertyToFilter] : this.changedItems.map(item => {return item[propertyToFilter]})
            }
            // console.log(request);

            axios.post("/vendormarketaccount/addrecomputation", request).then(() => {

              Vue.nextTick(() => {
                this.pendingChanges = false;
                this.changedItems = [];
                this.$bvToast.success("Änderungen gespeichert und Neuberechnung angestoßen.", {
									title: 'Erfolg',
									variant: 'success',
									solid: true
								});
              });
            }).catch(error => {
              this.modalError = {
                show: true,
                message: "Änderungen wurden aufgrund eines Fehlers verworfen.",
                error: error,
                title: 'Erstellen oder Update'
              };
            });
          }).catch(error => {
        this.modalError = {
          show: true,
          message: "Änderungen wurden aufgrund eines Fehlers verworfen.",
          error: error,
          title: 'Erstellen oder Update'
        };
      });
    },


    popupCreateVendorGroup(){
      this.modalShowVendorGroup = true;
    },

    vendorGroupClose(){
      this.vendorGroup.name = "";
      this.vendorGroup.members = [];
      this.vendors = this.vendors.map(item => {
        item.isSelected = false;
        return item;
      });
      this.modalShowVendorGroup = false;
    },

    validateVendorGroup(){
      if(this.vendorGroup.name == "" || this.vendorGroup.name == null){
        this.modalError = {
          show: true,
          message: "Bitte geben Sie einen Gruppennamen ein.",
          error: "",
          title: 'Gruppe erstellen'
        };
        return false;
      }
      if(this.vendorGroups.some(group => group.name == this.vendorGroup.name)){
        this.modalError = {
          show: true,
          message: "Gruppe mit diesem Namen existiert bereits.",
          error: "",
          title: 'Gruppe erstellen'
        };
        return false;
      }
      if(this.vendorGroup.members.length <= 0){
        this.modalError = {
          show: true,
          message: "Bitte wählen Sie minds Lieferanten aus.",
          error: "",
          title: 'Gruppe erstellen'
        };
        return false;
      }
      let intersectingVendors = this.selectedVendors.filter(vendor => this.alreadyUsedVendors.includes(vendor.value));
      if (intersectingVendors.length > 0) {
        intersectingVendors = intersectingVendors.map(vendor => vendor.text);
        this.modalError = {
          show: true,
          message: "Einer oder mehrere Lieferanten werden schon benutzt: " + intersectingVendors.join(", "),
          error: "",
          title: 'Gruppe erstellen'
        };
        return false;
      }
      return true;
    },

    saveVendorGroup(){
      let selectedVendors = this.vendors.filter(vendor => vendor.isSelected);
      selectedVendors = selectedVendors.map(item => item.value);
      this.vendorGroup.members = selectedVendors;


			if(!this.validateVendorGroup()){
        return;
      } else {
				this.vendorGroups.push({
					name: this.vendorGroup.name,
					members: this.vendorGroup.members,
				});
      }

        const vendorGroups = this.vendorGroups.map(group => {
          return {
            name: group.name,
            members: group.members
          }
        });

        const configRequest = {
					configGroup       : "VendorGroups",
					configKey         : "vendorGroups",
					configValue       : JSON.stringify(vendorGroups),
					lastUpdateReason  : "update VendorGroups"
        }

			axios.post('/vendormarketaccount/bygroups/save', configRequest)
					.then((res) => {
						console.log(res);
						this.loadItems();
						this.vendorGroupClose();
					}).catch(error => {
				this.modalError = {
					show: true,
					message: "VendorGruppe konnte nicht gespeichert werden.",
					error: error,
					title: 'Gruppe erstellen'
				};
			});
    },

    updateAllVendorGroupMembers(){
      this.vendorGroups.forEach(group => {
          group.members.forEach(member => {
            const item = this.items.find(item => item.vendorId == member);
            console.log(item);
            if( item && item.marketAccountId == this.currentlySelectedMarketAccountId) {
              item.fixedChargeNewMin = group.values.fixedChargeNewMin;
              item.fixedChargeNewMax = group.values.fixedChargeNewMax;
              item.percentChargeNewMin = group.values.percentChargeNewMin;
							item.percentChargeNewMax = group.values.percentChargeNewMax;
							item.repricingBufferNew = group.values.repricingBufferNew;
						} else if (!item){
              this.modalError = {
                show: true,
                message: "Für Lieferant " + this.vendors.find(vendor => vendor.value == member)?.text + " in der Gruppe '" + group.name + "' wurden keine Änderungen vorgenommen."
                + "Es existiert mit hoher Wahrscheinlichkeit kein VendorMarketAccount Eintrag für diesen Lieferanten. Für die restlichen Lieferanten wurden die Änderungen übernommen",
                error: "",
                title: 'Warnung'
              };
            }
          })
      });
    },

    createItem(vendorId) {
      if (vendorId == -1) {
        return;
      }
      this.modalShow_createNewRule = false;
      this.items.push({
        id: null,
        fixedChargeNewMin: 0,
        fixedChargeNewMax: 0,
        // fixedChargeNew: 0,
        // fixedChargeUsed: 0,
        percentChargeNewMax: 0,
        percentChargeNewMin: 0,
        // percentChargeUsedMax: 0,
        // percentChargeUsedMin: 0,
        repricingBufferNew: 0,
        // repricingBufferUsed: 0,
        itemNote: "",
        priority: 0,
        currentState: 0,
        lastUpdatetime: 0,
        lastUpdateReason: "",
        isActive: 0,
        vendorId: vendorId,
        marketAccountId: document.getElementById("sctMarketAccount").value
      });
    },

    sortItems(setPendingChanges = false) {
      this.sortAscendingOrDescendingWatchBlock = true;

      if(this.vendorOrMarketAccount == false) {
        this.vendors.sort(
            (v, w) => v.text.localeCompare(w.text)
                * this.sortAscendingOrDescending
        );
      }else{
        this.items.sort(
            (v, w) => this.passedMarketAccounts[v.marketAccountId].localeCompare(this.passedMarketAccounts[w.marketAccountId])
                * this.sortAscendingOrDescending
        );
      }

      Vue.nextTick(() => {
        this.pendingChanges = setPendingChanges;
      });
    },

    checkForChanges(){
      //checks each row for diffenreces that have been made
      this.items.forEach((item) => {

        const propertyToFilter = this.vendorOrMarketAccount ? 'marketAccountId' : 'vendorId';
        const oldItem = this.oldItems.find(oldItem => oldItem[propertyToFilter] === item[propertyToFilter]);
        const hasChanged = Object.keys(item).some(key =>
            item[key] !== oldItem[key] && item[propertyToFilter] === oldItem[propertyToFilter]
        )
        if (hasChanged) {
          if(!this.changedItems.some(cItem => cItem[propertyToFilter] === item[propertyToFilter])){
            this.changedItems.push(item);
            // console.log("item not found, pushing it: " + item[propertyToFilter]);
          } else {
            // console.log("item was found "  + item[propertyToFilter]);
            const changedItem = this.changedItems.find(
                changedItem => changedItem[propertyToFilter] === item[propertyToFilter]
            )
            // console.log("found Item: " + changedItem[propertyToFilter]);

            const changedItemIndex = this.changedItems.findIndex(cItem => cItem[propertyToFilter] === changedItem[propertyToFilter]);
            // console.log("index of changedItem " + changedItemIndex);
            this.changedItems[changedItemIndex] = item;
          }

        }
      })
    },

    formatItems() { //TODO
      // sanity check all input for all rules, (kill trailing zeros?)
      /*
					for(var itr in this.items)
					{
						var item = this.items[itr];
						if((item.priceMaxNew !== null) && (typeof item.priceMaxNew.replace === 'function'))				item.priceMaxNew 		= item.priceMaxNew			.replace(',', '.');
						if((item.priceMaxUsed !== null) && (typeof item.priceMaxUsed.replace === 'function'))			item.priceMaxUsed 		= item.priceMaxUsed			.replace(',', '.');
					}
				*/
    },
		openGroupModal(group) {
			this.selectedGroup.name = group.name;
			this.selectedGroup.members = group.members;
			this.modalShowGroupDetails = true;
		}
  },
	created(){
		this.vendors = this.passedVendors.map(( vendor ) => {
			return {
				value: vendor.id,
				text: vendor.shortName ?? vendor.name,
			};
		} );
		this.vendorGroups = this.passedVendorGroups.sort((a,b) => {
			return a.name.localeCompare( b.name);
		});
	},
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", () => {
        this.tHeight = window.innerHeight - 200;
      });
    });


    let dump = [];
    _.forIn(this.marketAccounts, function(value, key) {
      dump.push({
        value: parseInt(key),
        text: value
      });
    });

    dump.sort((a,b) => {
      return a.text.localeCompare( b.text);
    });
    this.marketAccounts = dump;
    let dump2 = [];
    this.loadItems();

  }
};
</script>
<style scoped>
.pointer:hover {
	text-decoration: underline;
	cursor: pointer;
}
</style>